var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip-base',_vm._g(_vm._b({ref:"tip",on:{"open":_vm.onOpen,"close":_vm.onClose},scopedSlots:_vm._u([(_vm.$slots.content)?{key:"content",fn:function(){return [_vm._t("content")]},proxy:true}:null],null,true)},'b-tooltip-base',_vm.computedProps,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }